import { ISanityImage } from '@rbi-ctg/menu';
import Picture from 'components/picture';
import { IImageFragment } from 'generated/sanity-graphql';
import { t } from 'state/intl/translations';

import { LogoContainer } from './styled';

export const WalmartLogo = ({
  image,
}: {
  image: ISanityImage | IImageFragment | ISanityImage | null | undefined;
}) => {
  return (
    <LogoContainer>
      <Picture width="$24" image={image} alt={t('deliveryLogoAlt')} />
    </LogoContainer>
  );
};
